import { render, staticRenderFns } from "./PlusMinus.vue?vue&type=template&id=a263960c&scoped=true&"
import script from "./PlusMinus.vue?vue&type=script&lang=js&"
export * from "./PlusMinus.vue?vue&type=script&lang=js&"
import style0 from "./PlusMinus.vue?vue&type=style&index=0&id=a263960c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a263960c",
  null
  
)

export default component.exports